import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi'
import type { ContactDetail, UKBranch } from '@/types/contact'

export const interests: string[] = [
  'General Enquiry',
  'Entrepreneurship & Innovation',
  'Education & Leadership',
  'Cultural Exchange',
  'Partnership Opportunity',
  'Volunteering',
  'Media & Press',
]

export const details: ContactDetail[] = [
  { Icon: FiMapPin, label: '5 Kojo Thompson Road, Accra, Ghana' },
  { Icon: FiPhone, label: '+233 24 444 3918' },
  { Icon: FiMail, label: 'info@ibonworld.org' },
]

export const ukBranch: UKBranch = {
  address: 'Unit 3, Office A, 1st Floor, 6-7 St Mary At Hill, London, EC3R 8EE, England',
  mapHref: 'https://maps.app.goo.gl/L7d4bNHpumkEFXSz6',
  phone: '+44 7919 785153',
  phoneHref: 'tel:+447919785153',
}

export const mapEmbedUrl =
  'https://www.google.com/maps?q=6-7%20St%20Mary%20At%20Hill%2C%20London%20EC3R%208EE&output=embed'

export const fieldClass =
  'h-14 w-full rounded-none border border-border bg-white px-4 text-ibon-dark transition-colors placeholder:text-text-muted focus:border-ibon-dark focus:outline-none'

export const labelClass = 'mb-3 block text-sm font-medium text-ibon-dark'
